<template>
  <div>
    <div class="banner">
      <b-container>
        <h1 class="banner-h1">Expand market by technology</h1>
        <p class="banner-p">Good morning, What would you like to do today?</p>
        <div class="banner-block">

          <div class="banner-card" v-for="item of banners" :key="item.title">
            <img class="banner-card-img" :src = "item.img"/>
            <div class="banner-context">
              <h2 class="banner-h2">{{item.title}}</h2>
              <p class="banner-card-p">{{item.desc}}</p>
            </div>
          </div>
        </div>
      </b-container>
    </div>

    <div class="reach">
      <b-container>
        <div class="reach-title">
          <h2 class="reach-h2">Reach new prospects</h2>
          <p class="reach-h2-desc">Connect with your best prospects through privacy-compliant digital or traditional channels to win new customers. Do it yourself or work with a specialist.</p>
        </div>

        <div class="reach-block">
          <div class="reach-card">
            <p class="reach-card-title">Consumer</p>
            <p class="reach-card-text">Find consumers by precise area, demographics, interesting and propensities</p>
            <b-btn class="reach-btn">Get Started</b-btn>
          </div>
          <div class="reach-card" style="background-image: url('http://dev.sl360.com/main/landBusiness.jpg') ">
            <p class="reach-card-title">Business</p>
            <div class="reach-card-text">Find lots of business by geographic area and characteristics</div>
            <b-btn class="reach-btn">Get Started</b-btn>
          </div>
        </div>
      </b-container>
    </div>

    <MSectionService />

    <div class="analyze">
      <b-container>
        <div class="analyze-title">
          <h2 class="analyze-h2">Analyze your customer data</h2>
          <p class="analyze-h2-desc">Gain insight into the demographic and psychographic characteristics of your customers, and identify prospects likely to become new customers.</p>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
  import MSectionService from '@/components/landings/MSectionService'

  export default {
    components: {
      MSectionService
    },
    data () {
      return {
        banners: [
          {
            title: 'Reach new prospect',
            desc: 'Through traditional direct mail or via a digital marketing campaign.',
            img: require('@/assets/images/landReach.jpg'),
            link: ''
          },
          {
            title: 'Manage my customer data',
            desc: 'By verifying or by enhancing the information I have collected.',
            img: require('@/assets/images/landManage.jpg'),
            link: ''
          },
          {
            title: 'Analyze my customers',
            desc: 'To discover characteristics they may share with others in my area.',
            img: require('@/assets/images/landAnalyze.jpg'),
            link: ''
          }
        ]
      }
    }
  }
</script>

<style scoped>
  .banner {
    background-color: #eee;
    padding-top: 32px;
    padding-bottom: 64px;
    background-image: url('http://dev.sl360.com/main/landBackWhite.jpg');
    background-size:100% 100%;
  }
  .banner-h1 {
    font-size: 48px;
  }
  .banner-p {
    font-size: 16px;
    margin-top: -4px;

  }
  .banner-block {
    margin-top: 32px;
    display: flex;
    justify-content: space-between;
  }

  .banner-card-img {
    width: 100%;
    height: auto;
    background: #eee;
  }
  .banner-card {
    width: 30%;
    background: #fff;
  }
  .banner-context {
    text-align: center;
    padding: 8px
  }
  .reach {
    padding-top: 32px;
    padding-bottom: 32px;
  }
  .reach-title, .analyze-title {
    text-align: center;
  }
  .reach-h2, .analyze-h2 {
    font-size: 24px;
  }

  .reach-h2-desc, .analyze-h2-desc {
    width: 80%;
    margin-left: 10%;
  }
  .reach-block {
    display: flex;
    justify-content: space-around;
    min-height: 40px;
  }

  .reach-card {
    position: relative;
    background-image: url('http://dev.sl360.com/main/landConsumer.jpg');
    background-size: 100% auto;
    padding: 16px;
    padding-bottom: 32px;
    width: 40%;
  }
  .reach-card-title {
    font-weight: bold;
    margin-bottom: 4px;
    font-size: 24px;
    color: #fff;
  }
  .reach-card-text {
    color: #fff;
  }
  .reach-btn {
    position: absolute;
    left: 16px;
    bottom: 8px;
    border: 0
  }
</style>



// WEBPACK FOOTER //
// src/components/landings/MV3.vue